var _defs, _ellipse, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g3, _path14, _path15, _path16, _path17, _g4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g5, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g6, _g7, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 478.639,
    height: 337.066,
    viewBox: "0 0 478.639 337.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -20.151,
    y1: -235.552,
    x2: -19.158,
    y2: -235.552,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#fcab64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb9031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -26.816,
    y1: -64.341,
    x2: -25.821,
    y2: -64.341,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6761",
    "data-name": "Groupe 6761",
    transform: "translate(-35 -32.497)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 236.992,
    cy: 4.655,
    rx: 236.992,
    ry: 4.655,
    transform: "translate(35 360.255)",
    fill: "#0d1111"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6744",
    "data-name": "Groupe 6744",
    transform: "translate(363.664 52.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9480",
    "data-name": "Trac\\xE9 9480",
    d: "M573.468,235.178l3.037,3.354a26.126,26.126,0,0,0-4.648,9.815l-4.516-.223-.476,9.538,4.523.227a25.948,25.948,0,0,0,3.657,10.225l-3.354,3.039,6.408,7.076,3.358-3.043a25.911,25.911,0,0,0,9.814,4.648l-.221,4.524,9.536.469.223-4.517a25.984,25.984,0,0,0,10.225-3.658l3.038,3.356,7.078-6.413-3.037-3.354a26.112,26.112,0,0,0,4.648-9.816l4.516.223.473-9.534-4.522-.225a26.013,26.013,0,0,0-3.658-10.226l3.357-3.042-6.412-7.079-3.352,3.046c-.025-.017-.048-.04-.073-.057-.606-.459-1.233-.892-1.866-1.289a26.109,26.109,0,0,0-7.876-3.3l.226-4.522-9.541-.469-.227,4.521a26.1,26.1,0,0,0-10.222,3.653l-3.038-3.353Zm10.873,4.895a19.326,19.326,0,0,1,22.993-2.2,18.559,18.559,0,0,1,1.864,1.293,19.316,19.316,0,1,1-24.857.908Z",
    transform: "translate(-482.934 -95.137)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9481",
    "data-name": "Trac\\xE9 9481",
    d: "M512.987,70.261l1.717,1.9a14.771,14.771,0,0,0-2.628,5.55l-2.555-.126-.269,5.394,2.558.129a14.656,14.656,0,0,0,2.069,5.782l-1.9,1.719,3.624,4,1.9-1.721a14.657,14.657,0,0,0,5.551,2.629l-.125,2.558,5.393.265.126-2.555a14.691,14.691,0,0,0,5.783-2.069l1.718,1.9,4-3.627-1.718-1.9a14.786,14.786,0,0,0,2.629-5.552l2.554.126.268-5.391-2.557-.128a14.636,14.636,0,0,0-1.282-4.335,14.81,14.81,0,0,0-.787-1.448l1.9-1.721-3.627-4-1.9,1.723c-.014-.01-.027-.023-.041-.033-.342-.259-.7-.5-1.056-.729a14.767,14.767,0,0,0-4.454-1.868l.128-2.557-5.4-.266-.128,2.558a14.749,14.749,0,0,0-5.781,2.066l-1.718-1.9Zm6.149,2.769a10.928,10.928,0,0,1,13-1.245,10.365,10.365,0,0,1,1.054.732,10.924,10.924,0,1,1-14.058.514Z",
    transform: "translate(-470.014 -59.249)",
    fill: "#ad4e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9482",
    "data-name": "Trac\\xE9 9482",
    d: "M460.62,67.431l-1.764-.087-.185,3.724,1.766.088a10.171,10.171,0,0,0,1.428,3.994l-1.309,1.187,2.5,2.762,1.311-1.188a10.113,10.113,0,0,0,3.833,1.814l-.087,1.767,3.724.183.087-1.765a10.141,10.141,0,0,0,3.994-1.428l1.186,1.31,2.764-2.5-1.186-1.309a10.2,10.2,0,0,0,1.815-3.834l1.764.087.185-3.723-1.766-.088a10.137,10.137,0,0,0-.885-2.994,10.342,10.342,0,0,0-.544-1l1.311-1.188-2.5-2.765-1.309,1.19c-.009-.007-.019-.016-.028-.022-.237-.179-.482-.348-.729-.5a10.184,10.184,0,0,0-3.076-1.29l.088-1.766L469.28,57.9l-.088,1.766a10.2,10.2,0,0,0-3.992,1.427l-1.186-1.309-2.764,2.5,1.186,1.309A10.2,10.2,0,0,0,460.62,67.431ZM465.5,64.2a7.547,7.547,0,0,1,8.979-.86,7.3,7.3,0,0,1,.728.505,7.543,7.543,0,1,1-9.707.355Z",
    transform: "translate(-458.671 -57.902)",
    fill: "#4e5e9f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6747",
    "data-name": "Groupe 6747",
    transform: "translate(94.396 112.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6746",
    "data-name": "Groupe 6746",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6745",
    "data-name": "Groupe 6745"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 369.833,
    height: 211.587,
    rx: 14.625,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "destop",
    transform: "translate(0.099 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    d: "M0,0H369.833a0,0,0,0,1,0,0V6.018a6.033,6.033,0,0,1-6.033,6.033H6.24A6.24,6.24,0,0,1,0,5.811V0A0,0,0,0,1,0,0Z",
    transform: "translate(369.833 12.051) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9483",
    "data-name": "Trac\\xE9 9483",
    d: "M140.335,142.626a2.963,2.963,0,1,0,2.963-2.963A2.964,2.964,0,0,0,140.335,142.626Z",
    transform: "translate(-118.116 -136.304)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9484",
    "data-name": "Trac\\xE9 9484",
    d: "M129.057,142.626a2.963,2.963,0,1,0,2.963-2.963A2.964,2.964,0,0,0,129.057,142.626Z",
    transform: "translate(-115.587 -136.304)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9485",
    "data-name": "Trac\\xE9 9485",
    d: "M118.42,142.626a2.963,2.963,0,1,0,2.963-2.963A2.964,2.964,0,0,0,118.42,142.626Z",
    transform: "translate(-113.202 -136.304)",
    fill: "#3a2a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9486",
    "data-name": "Trac\\xE9 9486",
    d: "M530.864,142.626a2.963,2.963,0,1,0,2.963-2.963A2.964,2.964,0,0,0,530.864,142.626Z",
    transform: "translate(-205.691 -136.304)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 95.422,
    height: 176.026,
    rx: 3.912,
    transform: "translate(343.557 202.697) rotate(180)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 95.422,
    height: 176.026,
    rx: 3.912,
    transform: "translate(238.85 202.697) rotate(180)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 95.422,
    height: 176.026,
    rx: 3.912,
    transform: "translate(135.329 202.697) rotate(180)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 13.253,
    cy: 13.253,
    r: 13.253,
    transform: "translate(247.857 44.617) rotate(-22.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 54.527,
    height: 3.698,
    transform: "translate(283.589 39.113)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 40.697,
    height: 3.698,
    transform: "translate(283.589 46.509)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 47.019,
    height: 3.698,
    transform: "translate(283.589 53.904)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 52.946,
    height: 3.698,
    transform: "translate(283.589 61.3)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 76.486,
    height: 3.556,
    transform: "translate(328.375 171.68) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 76.486,
    height: 3.556,
    transform: "translate(328.375 181.953) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 76.486,
    height: 3.556,
    transform: "translate(328.375 192.226) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 51.119,
    height: 3.556,
    transform: "translate(127.575 43.661) rotate(180)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 37.88,
    height: 3.556,
    transform: "translate(127.575 50.773) rotate(180)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 43.764,
    height: 3.556,
    transform: "translate(127.575 57.885) rotate(180)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 49.28,
    height: 3.556,
    transform: "translate(127.575 64.997) rotate(180)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    d: "M3.1,0H84.616a3.1,3.1,0,0,1,3.1,3.1V41.153a3.1,3.1,0,0,1-3.1,3.1H3.1a3.1,3.1,0,0,1-3.1-3.1V3.1A3.1,3.1,0,0,1,3.1,0Z",
    transform: "translate(234.899 78.431) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 4.741,
    height: 20.546,
    transform: "translate(230.553 76.456) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 4.741,
    height: 34.771,
    transform: "translate(223.441 76.456) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 4.741,
    height: 4.346,
    transform: "translate(216.723 76.456) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 4.741,
    height: 6.322,
    transform: "translate(210.007 76.456) rotate(180)",
    fill: "#c35e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 4.741,
    height: 12.644,
    transform: "translate(203.289 76.456) rotate(180)",
    fill: "#c35e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 4.741,
    height: 29.239,
    transform: "translate(196.572 76.456) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 4.741,
    height: 22.127,
    transform: "translate(189.855 76.456) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 4.741,
    height: 17.385,
    transform: "translate(183.138 76.456) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 4.741,
    height: 12.644,
    transform: "translate(176.421 76.456) rotate(180)",
    fill: "#c35e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 4.741,
    height: 17.385,
    transform: "translate(156.27 76.456) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 4.741,
    height: 6.322,
    transform: "translate(169.704 76.456) rotate(180)",
    fill: "#c35e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 4.741,
    height: 4.346,
    transform: "translate(162.987 76.456) rotate(180)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 35.956,
    height: 35.956,
    rx: 1.469,
    transform: "translate(314.713 121.895) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 35.956,
    height: 35.956,
    rx: 1.469,
    transform: "translate(209.019 121.895) rotate(180)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    d: "M3.1,0H32.855a3.1,3.1,0,0,1,3.1,3.1V32.855a3.1,3.1,0,0,1-3.1,3.1H3.1a3.1,3.1,0,0,1-3.1-3.1V3.1A3.1,3.1,0,0,1,3.1,0Z",
    transform: "translate(108.46 121.895) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 5.463,
    height: 5.532,
    transform: "translate(338.716 162.395) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 5.463,
    height: 5.532,
    transform: "translate(338.911 172.47) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 5.463,
    height: 5.532,
    transform: "translate(338.911 182.743) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 5.463,
    height: 5.532,
    transform: "translate(338.911 193.016) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9487",
    "data-name": "Trac\\xE9 9487",
    d: "M171.728,345.937h70.849a1.778,1.778,0,0,0,1.778-1.778h0a1.778,1.778,0,0,0-1.778-1.778H171.728a1.778,1.778,0,0,0-1.778,1.778h0A1.778,1.778,0,0,0,171.728,345.937Z",
    transform: "translate(-124.757 -181.763)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9488",
    "data-name": "Trac\\xE9 9488",
    d: "M171.728,359.18h70.849a1.778,1.778,0,0,0,1.778-1.778h0a1.779,1.779,0,0,0-1.778-1.779H171.728a1.779,1.779,0,0,0-1.778,1.779h0A1.778,1.778,0,0,0,171.728,359.18Z",
    transform: "translate(-124.757 -184.733)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9489",
    "data-name": "Trac\\xE9 9489",
    d: "M171.728,372.422h70.849a1.778,1.778,0,0,0,1.778-1.778h0a1.778,1.778,0,0,0-1.778-1.778H171.728a1.778,1.778,0,0,0-1.778,1.778h0A1.778,1.778,0,0,0,171.728,372.422Z",
    transform: "translate(-124.757 -187.703)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9490",
    "data-name": "Trac\\xE9 9490",
    d: "M171.728,385.665h70.849a1.778,1.778,0,0,0,1.778-1.778h0a1.778,1.778,0,0,0-1.778-1.778H171.728a1.778,1.778,0,0,0-1.778,1.778h0A1.778,1.778,0,0,0,171.728,385.665Z",
    transform: "translate(-124.757 -190.672)",
    fill: "#4e5e9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 5.452,
    height: 5.532,
    transform: "translate(129.919 162.395) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 5.452,
    height: 5.532,
    transform: "translate(130.114 172.47) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 5.452,
    height: 5.532,
    transform: "translate(130.114 182.743) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 5.452,
    height: 5.532,
    transform: "translate(130.114 193.016) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    d: "M3.1,0H84.616a3.1,3.1,0,0,1,3.1,3.1V32.46a3.1,3.1,0,0,1-3.1,3.1H3.1A3.1,3.1,0,0,1,0,32.46V3.1A3.1,3.1,0,0,1,3.1,0Z",
    transform: "translate(234.899 197.955) rotate(180)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6752",
    "data-name": "Groupe 6752",
    transform: "translate(38.386 137.383)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9491",
    "data-name": "Trac\\xE9 9491",
    d: "M116.977,226.507l9.422,9.819v9.551l-5.943-4.431Z",
    transform: "translate(-56.769 -180.89)",
    fill: "#bc6317"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9492",
    "data-name": "Trac\\xE9 9492",
    d: "M311.262,434.949l-5.758,1.8s-12.289-32.783-15.362-40.711c-.587-1.516-.531-5.831-.531-5.831l8.3-2.06a34.821,34.821,0,0,0,.777,5.022c.358.717,5.075,10.88,6.031,14.706S311.262,434.949,311.262,434.949Z",
    transform: "translate(-95.482 -217.137)",
    fill: "#ffa397"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9493",
    "data-name": "Trac\\xE9 9493",
    d: "M261.654,223.955l-4.406,3.1s-9.935-4.174-8.519-5.8c.569-.656,5.052,1.629,5.052,1.629s-4.561-8.8-3.638-9.124,5.862.83,5.862.83Z",
    transform: "translate(-86.283 -178.017)",
    fill: "#ffa397"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9494",
    "data-name": "Trac\\xE9 9494",
    d: "M275.282,393.989l-8.718-2.745a13.382,13.382,0,0,0,.421,6.854c1.071,2.818,5.4,42.389,5.4,42.389l5.853-.223s.611-20.006.19-26.064-3.146-15.783-3.146-15.783Z",
    transform: "translate(-90.254 -217.832)",
    fill: "#ffa397"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9495",
    "data-name": "Trac\\xE9 9495",
    d: "M290.34,331.77a52.323,52.323,0,0,1,2.773,12.359c.773,11.252.164,27.243.493,34.858l-10.8,2.285c-.716-4.6-3.429-33.523-3.429-33.523s-2.3,25.815-2.47,33.713l-11.95-.962c0-9.651,3.9-47.035,3.9-47.035Z",
    transform: "translate(-89.953 -204.495)",
    fill: "#2e3537"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9496",
    "data-name": "Trac\\xE9 9496",
    d: "M314.784,453.62c-2.5.87-13.165,4.534-13.517,3.961-1.307-2.128,5.357-4.525,6.813-7.3.7-1.336,5.758-1.8,5.758-1.8l1.27,4.289S315.117,453.5,314.784,453.62Z",
    transform: "translate(-98.058 -230.666)",
    fill: "#3a2a4e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9497",
    "data-name": "Trac\\xE9 9497",
    d: "M74.365,382.7c2.517.835,13.227,4.348,13.571,3.771,1.277-2.146-5.42-4.45-6.915-7.208l-5.783-1.716-1.209,4.306S74.029,382.591,74.365,382.7Z",
    transform: "translate(-47.138 -214.761)",
    fill: "#feab44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9498",
    "data-name": "Trac\\xE9 9498",
    d: "M315.2,446.495l-1.65-6.865-6.379,2.678,2.272,5.984Z",
    transform: "translate(-99.42 -228.682)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9499",
    "data-name": "Trac\\xE9 9499",
    d: "M282.825,352.225l-2.18-.5-.308,34.464Z",
    transform: "translate(-93.402 -208.97)",
    fill: "#c35e4a",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9500",
    "data-name": "Trac\\xE9 9500",
    d: "M277.11,459.561H263.046c-.553-2.658,6.067-2.572,8.607-4.889l5.853-.254.487,3.568S278.238,459.561,277.11,459.561Z",
    transform: "translate(-89.518 -231.998)",
    fill: "#3a2a4e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9501",
    "data-name": "Trac\\xE9 9501",
    d: "M242.716,277.289c.541.837,13.694-5.575,17.148-5.814a34.627,34.627,0,0,0,7.707-1.459s-.361-16.86-1.887-22.223c-1.424-5-14.363-17.493-14.363-17.493l5.279-3.793s14.825,13.694,16.787,20.261c1.9,6.374.889,13.8,3.053,27.6,1.386,8.841,4.848,26.926,4.826,33.8-.019,5.5-21.8,4.793-21.8,4.793l-3.2-30.3-13.625,3.893a5.633,5.633,0,0,1-5.535-2.8l-12.618-22.086,5.317-3.739S240.446,273.776,242.716,277.289Z",
    transform: "translate(-80.879 -180.89)",
    fill: "#f6c342"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9502",
    "data-name": "Trac\\xE9 9502",
    d: "M267.568,278.878l-.6-4.748a4.534,4.534,0,0,1-3.909-.012c-2.186-1-2.455-5.988-2.455-5.988l-1.829.359a.41.41,0,0,1-.4-.628c.829-1.38,2.375-4.146,2.081-5.165-.659-2.284.215-4.525,4.3-5.7,3.592-1.033,5.93,3.041,6.7,5.941a113.787,113.787,0,0,1,2.413,14.684S270.237,279.822,267.568,278.878Z",
    transform: "translate(-88.463 -187.69)",
    fill: "#ffa397"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9503",
    "data-name": "Trac\\xE9 9503",
    d: "M273.026,268.615a3.224,3.224,0,0,1-2.451.12c-1.539-.438-2.022-4.965-2.022-4.965s-.215-2.784-1.683-1.309c-1,1.005-1.108,3.39-2.607,1.859-1.14-1.162-.009-5.306-4.618-5.6-2.363-.147.837-4.378,4.917-5.931a7.867,7.867,0,0,1,7.944,1.54C278.855,260.432,273.026,268.615,273.026,268.615Z",
    transform: "translate(-88.582 -186.678)",
    fill: "#c35e4a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9504",
    "data-name": "Trac\\xE9 9504",
    d: "M262.368,267.253c.068.425.254.748.417.722s.24-.391.173-.815-.254-.747-.417-.721S262.3,266.829,262.368,267.253Z",
    transform: "translate(-89.368 -189.844)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9505",
    "data-name": "Trac\\xE9 9505",
    d: "M263.532,274.781a.514.514,0,0,0,.108-.029c.415-.161.464-.8.465-.826a.083.083,0,0,0-.165-.012c0,.005-.044.56-.361.683-.238.091-.6-.079-1.034-.494a.083.083,0,1,0-.114.12C262.871,274.64,263.24,274.827,263.532,274.781Z",
    transform: "translate(-89.381 -191.503)",
    fill: "#ffa397",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6750",
    "data-name": "Groupe 6750",
    transform: "translate(63.595 2.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6749",
    "data-name": "Groupe 6749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6748",
    "data-name": "Groupe 6748"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 67.758,
    height: 105.165,
    rx: 9.879,
    transform: "matrix(0.066, -0.998, 0.998, 0.066, 0, 67.61)",
    fill: "#4e5e9f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9506",
    "data-name": "Trac\\xE9 9506",
    d: "M134.058,234.2l85.257,5.332a1.785,1.785,0,0,0,1.892-1.657l3.385-48.443a1.785,1.785,0,0,0-1.669-1.906l-85.257-5.332a1.785,1.785,0,0,0-1.892,1.658l-3.385,48.442A1.785,1.785,0,0,0,134.058,234.2Z",
    transform: "translate(-123.82 -173.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9507",
    "data-name": "Trac\\xE9 9507",
    d: "M230.747,246.35l-19.169-26.79a1.071,1.071,0,0,0-1.565-.193L180.286,244.6l49.583,3.327A1,1,0,0,0,230.747,246.35Z",
    transform: "translate(-134.561 -182.057)",
    fill: "#c8c0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9508",
    "data-name": "Trac\\xE9 9508",
    d: "M189.946,241.2l-24.021-42.87a1.072,1.072,0,0,0-1.769-.149l-30.771,38.174a.837.837,0,0,0,.6,1.361Z",
    transform: "translate(-124.002 -177.274)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9509",
    "data-name": "Trac\\xE9 9509",
    d: "M224.64,203.332a6.038,6.038,0,1,0,4.9-6.907A5.99,5.99,0,0,0,224.64,203.332Z",
    transform: "translate(-144.487 -176.948)",
    fill: "#feab44"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9510",
    "data-name": "Trac\\xE9 9510",
    d: "M227.646,264.216s-2.5-8.916-3.4-8.092c-1.043.951.419,4.542.419,4.542s-6.3-11.579-8.006-5.541c-1.149,4.059,6.4,12.32,6.4,12.32Z",
    transform: "translate(-79.096 -186.916)",
    fill: "#ffa397"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9511",
    "data-name": "Trac\\xE9 9511",
    d: "M149.277,264.069v-4.385s6.855-4.544,7.812-4.065-3.348,4.065-3.348,4.065h9.169a12.94,12.94,0,0,1-5.661,3.428A72.529,72.529,0,0,1,149.277,264.069Z",
    transform: "translate(-64.013 -187.41)",
    fill: "#84564a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9512",
    "data-name": "Trac\\xE9 9512",
    d: "M279.791,452.475l-5.853.273-.734-6.334,6.59-.5Z",
    transform: "translate(-91.803 -230.092)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9513",
    "data-name": "Trac\\xE9 9513",
    d: "M265.455,298.743l1.428-.476a.453.453,0,0,1,.543.645l-1.666,2.195Z",
    transform: "translate(-90.065 -196.976)",
    fill: "#bc6317"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6751",
    "data-name": "Groupe 6751",
    transform: "translate(0 112.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9514",
    "data-name": "Trac\\xE9 9514",
    d: "M41.1,427.834l39.956-113.12a.556.556,0,1,0-1.048-.371L39.365,427.825Z",
    transform: "translate(-39.365 -313.447)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9515",
    "data-name": "Trac\\xE9 9515",
    d: "M83.3,427.811l39.073-113.1a.556.556,0,1,0-1.052-.363l-39.2,113.465Z",
    transform: "translate(-48.952 -313.447)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9516",
    "data-name": "Trac\\xE9 9516",
    d: "M131.994,427.637l-39.07-113.23h30.552l39.065,113.217,1.185-.014L124.269,313.3h-32.9l39.455,114.346Z",
    transform: "translate(-51.026 -313.295)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9517",
    "data-name": "Trac\\xE9 9517",
    d: "M67.1,387.055H98.829a.556.556,0,0,0,0-1.112H67.1a.556.556,0,0,0,0,1.112Z",
    transform: "translate(-45.46 -329.586)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9518",
    "data-name": "Trac\\xE9 9518",
    d: "M60.334,408.932H91.118a.556.556,0,0,0,0-1.112H60.334a.556.556,0,1,0,0,1.112Z",
    transform: "translate(-43.943 -334.492)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9519",
    "data-name": "Trac\\xE9 9519",
    d: "M76.305,364.215h30.948a.556.556,0,1,0,0-1.112H76.305a.556.556,0,0,0,0,1.112Z",
    transform: "translate(-47.524 -324.465)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9520",
    "data-name": "Trac\\xE9 9520",
    d: "M82.634,344.95h31.2a.556.556,0,1,0,0-1.112h-31.2a.556.556,0,0,0,0,1.112Z",
    transform: "translate(-48.944 -320.144)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9521",
    "data-name": "Trac\\xE9 9521",
    d: "M44.806,450.453H76.823a.556.556,0,1,0,0-1.112H44.806a.556.556,0,1,0,0,1.112Z",
    transform: "translate(-40.459 -343.803)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9522",
    "data-name": "Trac\\xE9 9522",
    d: "M53.191,426.516H84.629a.556.556,0,1,0,0-1.112H53.191a.556.556,0,1,0,0,1.112Z",
    transform: "translate(-42.337 -338.435)",
    fill: "#d6cdec"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9523",
    "data-name": "Trac\\xE9 9523",
    d: "M98.037,271.177l-15.828-2.755s1.185,29.208-.2,39.573c-1.462,10.921-8.256,44.517-8.256,44.517l8.937,3.1s7.983-33.644,9.9-44.025C94.432,301.558,98.037,271.177,98.037,271.177Z",
    transform: "translate(-47.076 -190.289)",
    fill: "#1d2223"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9524",
    "data-name": "Trac\\xE9 9524",
    d: "M155.7,168.559s2.233,3.507,1.754,4.464-.718.558-.718.558.16,2.79-1.355,2.79-3.347-4.225-3.905-4.3-.718,2.631-1.674,2.87,0-2.152,0-3.108S152.116,165.69,155.7,168.559Z",
    transform: "translate(-64.035 -167.703)",
    fill: "#84564a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9525",
    "data-name": "Trac\\xE9 9525",
    d: "M115,217.911l2.06-5.3a4.3,4.3,0,0,0,3.589.934c2.248-.393,3.7-4.9,3.7-4.9l1.591.772a.389.389,0,0,0,.521-.479c-.427-1.466-1.175-4.378-.659-5.24,1.157-1.935.9-4.2-2.565-6.27-3.045-1.817-6.175,1.355-7.58,3.83-2.882,5.073-6.554,13.749-6.554,13.749S113.565,218.471,115,217.911Z",
    transform: "translate(-55.004 -174.249)",
    fill: "#84564a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9526",
    "data-name": "Trac\\xE9 9526",
    d: "M128.361,196.614s2.655,2.4.659,3.91c-3.022,2.288-4.959-2.026-5.968-1.614s.222,3.177-1.323,3-1.247-3.3-3.543-1.447c-.99.8-.364,2.191-.346,3.111s.728,3.887-1,3.956-1.909-2.05-1.909-2.05-2.681,1.618-2.67-1.478a2.669,2.669,0,0,1-3.068-2.7c-.3-3.79,3.408-2.216,3.062-3.728s-1.839-4.011.206-5.1a3.234,3.234,0,0,1,3.465.022s-.857-2.331.842-2.769,2.249,1.407,2.249,1.407a4.336,4.336,0,0,1,5.634-1.263c2.049,1.126.616,3.948.616,3.948a1.937,1.937,0,0,1,2.7-.143A2.33,2.33,0,0,1,128.361,196.614Z",
    transform: "translate(-55.019 -172.543)",
    fill: "#3a2a4e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9527",
    "data-name": "Trac\\xE9 9527",
    d: "M126.613,213.091l-1.269-1.377s-1.061.883-.364,1.608S126.613,213.091,126.613,213.091Z",
    transform: "translate(-58.511 -177.572)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9528",
    "data-name": "Trac\\xE9 9528",
    d: "M128.013,205.84c-.158.4-.162.773-.009.833s.406-.213.565-.613.162-.773.009-.833S128.171,205.441,128.013,205.84Z",
    transform: "translate(-59.217 -176.116)",
    fill: "#050505"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9529",
    "data-name": "Trac\\xE9 9529",
    d: "M96.549,355.5c2.242,1.416,11.793,7.4,12.265,6.925,1.756-1.776-4.191-5.623-4.978-8.66-.379-1.46-5.2-3.057-5.2-3.057l-2.21,3.889S96.25,355.312,96.549,355.5Z",
    transform: "translate(-52.149 -208.742)",
    fill: "#feab44"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9530",
    "data-name": "Trac\\xE9 9530",
    d: "M100.621,268.814s21.936,22.041,21.932,27.966c0,6.448-19.662,38.484-19.662,38.484l-8.612-4.2,15.182-32.792s-17.205-14.777-20.984-19.513c-5.641-7.072-2.121-16.2-2.121-16.2Z",
    transform: "translate(-49.659 -188.975)",
    fill: "#2e3537"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9531",
    "data-name": "Trac\\xE9 9531",
    d: "M134.785,250.863v6.481s-21.474,2.725-25.141.378-3.655-12.368-3.655-12.368l-4.708,14.714s-16.768,1.4-16.628-2.45c.478-13.146,4.375-22.575,11.153-31.878,3.934-5.4,7.813-5.5,7.815-5.494l5.9,2.9s3.965,12.292,4.443,17.873,1.257,9.843,1.257,9.843Z",
    transform: "translate(-49.521 -179.486)",
    fill: "#f6c342"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9532",
    "data-name": "Trac\\xE9 9532",
    d: "M111.114,250.072l-.935-8.291a.559.559,0,0,0-1.112.018L107.5,261.364Z",
    transform: "translate(-54.644 -184.203)",
    fill: "#feab44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6757",
    "data-name": "Groupe 6757",
    transform: "translate(332.873 203.553)"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9533",
    "data-name": "Trac\\xE9 9533",
    d: "M451.953,316.488s-7.6-3.909-7.413-2.6,2.712,1.843,2.712,1.843-5.208.3-4.583,2.748c1,3.93,9.8,3.593,9.8,3.593Z",
    transform: "translate(-424.28 -266.594)",
    fill: "#84564a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9534",
    "data-name": "Trac\\xE9 9534",
    d: "M457.2,317l-.507-7.109,17.412-2.165s16.68-23.138,22.3-21.213c4.7,1.608-2.984,14.2-11.736,23.034C476.211,318.082,471.123,316.713,457.2,317Z",
    transform: "translate(-427.437 -260.489)",
    fill: "#bc6317"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9535",
    "data-name": "Trac\\xE9 9535",
    d: "M499.559,289.05a4.857,4.857,0,0,0-3.41.6c.608,3.477-7.588,12.362-15.033,19.874-7.471,7.537-12.316,7.353-22.929,7.4l.054.749c13.922-.285,19.009,1.084,27.471-7.453C494.464,301.389,504.256,290.659,499.559,289.05Z",
    transform: "translate(-427.772 -261.057)",
    fill: "#feab44"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6755",
    "data-name": "Groupe 6755",
    transform: "translate(0 39.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6754",
    "data-name": "Groupe 6754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6753",
    "data-name": "Groupe 6753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9536",
    "data-name": "Trac\\xE9 9536",
    d: "M425.032,383.159l104.734,41.863a9.62,9.62,0,0,0,12.505-5.363L566.7,358.535a9.621,9.621,0,0,0-5.363-12.505L456.607,304.166a9.621,9.621,0,0,0-12.505,5.364l-24.432,61.125A9.621,9.621,0,0,0,425.032,383.159Z",
    transform: "translate(-418.979 -303.476)",
    fill: "#4e5e9f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9537",
    "data-name": "Trac\\xE9 9537",
    d: "M434.209,378.058,533.941,417.5a2.241,2.241,0,0,0,2.9-1.245l22.837-56.528a2.241,2.241,0,0,0-1.254-2.924L458.694,317.36a2.24,2.24,0,0,0-2.9,1.244l-22.837,56.529A2.242,2.242,0,0,0,434.209,378.058Z",
    transform: "translate(-422.077 -306.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9538",
    "data-name": "Trac\\xE9 9538",
    d: "M547.752,433.1,535.86,395.575a3.178,3.178,0,0,0-4.236-1.98l-43.444,17.838,57.913,23.21A1.252,1.252,0,0,0,547.752,433.1Z",
    transform: "translate(-434.497 -323.631)",
    fill: "#c8c0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9539",
    "data-name": "Trac\\xE9 9539",
    d: "M499.491,410.845l-12.437-62.46-53.22,34.73a1.05,1.05,0,0,0,.188,1.856Z",
    transform: "translate(-422.204 -313.547)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9540",
    "data-name": "Trac\\xE9 9540",
    d: "M559.234,376.367a7.58,7.58,0,1,0,8.536-6.345A7.522,7.522,0,0,0,559.234,376.367Z",
    transform: "translate(-450.415 -318.382)",
    fill: "#feab44"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9541",
    "data-name": "Trac\\xE9 9541",
    d: "M503.509,258.136s-2.451,5.542-3.592,6.648a6.311,6.311,0,0,0-1.111,1.464.546.546,0,0,0,.287.777l.87.327a.284.284,0,0,1,.178.336c-.266,1.062-1.218,5.265.173,6.114a11.137,11.137,0,0,0,4.214,1.406l.056,4.741,6.435,2.623-.234-8.335S516.436,254.308,503.509,258.136Z",
    transform: "translate(-436.865 -254.042)",
    fill: "#84564a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9542",
    "data-name": "Trac\\xE9 9542",
    d: "M503.863,259.665c1.974,1.9,2.159,4.264,3.139,6.045.8,1.45,1.251-2.486,2.535-1.272,1.124,1.062.409,2.255-.285,3a2.481,2.481,0,0,0-.607,2.06c.915,6.156,3.783,29.491,3.783,29.491s20.522-6.415,8.6-19.338c-8.072-8.75.181-14.842-1.981-20.362C514.445,247.537,499.025,255,503.863,259.665Z",
    transform: "translate(-437.806 -253)",
    fill: "#c35e4a"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9543",
    "data-name": "Trac\\xE9 9543",
    d: "M503.021,265.523c-.216.375-.27.771-.119.884s.448-.1.665-.477.27-.771.119-.884S503.237,265.148,503.021,265.523Z",
    transform: "translate(-437.78 -255.695)",
    fill: "#3a2a4e"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9544",
    "data-name": "Trac\\xE9 9544",
    d: "M500.722,272.946l1.84.241s-.109,1.363-1.095,1.213S500.722,272.946,500.722,272.946Z",
    transform: "translate(-437.304 -257.473)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6756",
    "data-name": "Groupe 6756",
    transform: "translate(61.618 52.088)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9545",
    "data-name": "Trac\\xE9 9545",
    d: "M499.048,320.277l-.368-.132a.844.844,0,0,0-.271.1l.756.26A.705.705,0,0,0,499.048,320.277Z",
    transform: "translate(-498.41 -320.145)",
    fill: "#ff9d40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9546",
    "data-name": "Trac\\xE9 9546",
    d: "M469.568,457.388c-.478-2.2,4.484-2.31,6.617-4.481,1.249-1.271,7.092.013,7.092.013v3.323a1.145,1.145,0,0,1-1.146,1.145Z",
    transform: "translate(-430.316 -297.703)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9547",
    "data-name": "Trac\\xE9 9547",
    d: "M501.528,457.388c-.478-2.2,4.484-2.31,6.618-4.481,1.249-1.271,6.54.013,6.54.013l.367,2.984a1.321,1.321,0,0,1-1.312,1.483Z",
    transform: "translate(-437.483 -297.703)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9548",
    "data-name": "Trac\\xE9 9548",
    d: "M485.79,334.77s-7.393,34.64-8.427,46.624c-.972,11.268-.142,45.221-.142,45.221H485.8L486.98,387.3l6.192-32.883s.238,22.183.665,28.917c.7,10.971,8.187,43.562,8.187,43.562l7.917-.144s-5.417-35.678-6.054-48.072c-.475-9.244.634-38.988.634-38.988Z",
    transform: "translate(-431.966 -271.337)",
    fill: "#2e3537"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9549",
    "data-name": "Trac\\xE9 9549",
    d: "M491.9,305.451s5.038-17.984,10.791-19.6c4.81-1.348,6.666,1.228,6.666,1.228s6.5,16.939-2.171,43.054c-.483,1.455-20.429-2.819-20.429-2.819S490.865,308.34,491.9,305.451Z",
    transform: "translate(-434.178 -260.28)",
    fill: "#f6c342"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9550",
    "data-name": "Trac\\xE9 9550",
    d: "M487.873,323.151s8.2.905,13.99-2.239c6.529-3.544,8-31.292,8-31.292s5.464,17.58-2.678,41.448c-.527,1.544-20.429-2.819-20.429-2.819Z",
    transform: "translate(-434.178 -261.212)",
    fill: "#feab44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9551",
    "data-name": "Trac\\xE9 9551",
    d: "M495.833,363.07l1.586-7.983-.438-10.061Z",
    transform: "translate(-436.214 -273.637)",
    fill: "#585fcc",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9552",
    "data-name": "Trac\\xE9 9552",
    d: "M485.373,442.665l3.449-36.321L487.7,442.665Z",
    transform: "translate(-433.868 -287.387)",
    fill: "#585fcc",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9553",
    "data-name": "Trac\\xE9 9553",
    d: "M515.475,440.738l-3.37-43.675c2.8,26.954,5.732,43.659,5.732,43.659Z",
    transform: "translate(-439.863 -285.306)",
    fill: "#585fcc",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9554",
    "data-name": "Trac\\xE9 9554",
    d: "M534.585,328.168s-7.5,3.648-6.189,3.724a22.363,22.363,0,0,0,4.039-.49s-4.389,5.886.49,6.419c1.721.188,2.258-2.312,3.551-3.848a6.367,6.367,0,0,0,1.553-4.336Z",
    transform: "translate(-443.482 -269.856)",
    fill: "#84564a"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9555",
    "data-name": "Trac\\xE9 9555",
    d: "M534.5,320.441l-5.489-2.344.038-16.986s-21.028-5.571-19.661-13.293c.847-4.783,9.056-1.09,22.148,5.326C536.811,295.727,536.612,308.92,534.5,320.441Z",
    transform: "translate(-439.24 -260.32)",
    fill: "#f6c342"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9556",
    "data-name": "Trac\\xE9 9556",
    d: "M445.52,323.989s4.534.016,5.118-1.909-4.419,0-4.419,0Z",
    transform: "translate(-424.931 -268.299)",
    fill: "#ff9d40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9557",
    "data-name": "Trac\\xE9 9557",
    d: "M442.676,319.038s4.074-3.956,6.019-2.687,4.167,5.734-2.828,5.437C442.134,321.63,442.676,319.038,442.676,319.038Z",
    transform: "translate(-424.287 -267.15)",
    fill: "#84564a"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6758",
    "data-name": "Groupe 6758",
    transform: "translate(261.719 207.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9558",
    "data-name": "Trac\\xE9 9558",
    d: "M339.12,309.961l22.816,18.748-12.948,1.417-21.731-18.1Z",
    transform: "translate(-327.258 -269.378)",
    fill: "#3a2a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9559",
    "data-name": "Trac\\xE9 9559",
    d: "M389.613,264.287s-1.591,4.8-2.638,5.415c-.566.334-1.41.8-2.065,1.165a.4.4,0,0,0,.119.743l1.5.283s-1.842,4.851.064,6.407,3.226.617,3.226.617l-.828,4.934,5.6.593s1.627-7.953,3.3-13.816C398.533,268.411,395.758,259.955,389.613,264.287Z",
    transform: "translate(-340.14 -258.863)",
    fill: "#ffa397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9560",
    "data-name": "Trac\\xE9 9560",
    d: "M389.756,261.893s-2.29,1.54-.491,2.595a4.146,4.146,0,0,0,3.373.455s-1.4,3.839.136,4.295,1.887-1.584,2.631-.565-.345,6.938,1.659,7.727,7.541-2.1,6.94-7.345S401.868,254.838,389.756,261.893Z",
    transform: "translate(-341.008 -258.016)",
    fill: "#3a2a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9561",
    "data-name": "Trac\\xE9 9561",
    d: "M405.648,261.246s3.6-5.823,6.7-2.655c2.188,2.234,3.465,5.8-4.864,7.588C406.143,266.467,405.648,261.246,405.648,261.246Z",
    transform: "translate(-344.836 -257.647)",
    fill: "#3a2a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9562",
    "data-name": "Trac\\xE9 9562",
    d: "M355.171,323.558s-9.7-5.782-9.94-3.928,4.76,2.451,4.31,3.818c-.877,2.669-13.245-3.075-11.207-.809,4.273,4.749,16.576,6.844,16.576,6.844Z",
    transform: "translate(-329.691 -271.464)",
    fill: "#ffa397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9563",
    "data-name": "Trac\\xE9 9563",
    d: "M369.274,301.819l5.444-2.367,5.007,10.189-2.894,6.6-2.332-.4Z",
    transform: "translate(-336.68 -267.022)",
    fill: "#bc6317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9564",
    "data-name": "Trac\\xE9 9564",
    d: "M368.529,299.143s-5.795-8.851,0-11.282,5.443,8.915,5.443,8.915Z",
    transform: "translate(-335.935 -264.346)",
    fill: "#ffa397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9565",
    "data-name": "Trac\\xE9 9565",
    d: "M367.963,293.357h0a.729.729,0,0,0,.922-.461l4.353-13.06a.728.728,0,0,0-.461-.922h0a.729.729,0,0,0-.922.461L367.5,292.435A.729.729,0,0,0,367.963,293.357Z",
    transform: "translate(-336.274 -262.408)",
    fill: "#3a2a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9566",
    "data-name": "Trac\\xE9 9566",
    d: "M355.4,459.249l16.8.263a1.536,1.536,0,0,0,1.559-1.493l.076-2.679-6.81-.309S354.8,456.925,355.4,459.249Z",
    transform: "translate(-333.563 -301.91)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9567",
    "data-name": "Trac\\xE9 9567",
    d: "M373.245,342.684,380.3,384.7l14.212,42.132,9.42-2.617-13.584-45.891,1.907-35.267Z",
    transform: "translate(-337.57 -276.717)",
    fill: "#1d2223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9568",
    "data-name": "Trac\\xE9 9568",
    d: "M389.439,457,405.733,453a1.536,1.536,0,0,0,1.135-1.814l-.629-2.924-8.118,2.249S388.145,454.129,389.439,457Z",
    transform: "translate(-341.176 -300.391)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9569",
    "data-name": "Trac\\xE9 9569",
    d: "M367.845,429.153l9.147.447-1.9-44.586,15.409-45.083-18.31,2.185L365.177,385.4Z",
    transform: "translate(-335.761 -276.099)",
    fill: "#2e3537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9570",
    "data-name": "Trac\\xE9 9570",
    d: "M357.714,316.321l-2.074,5.842s12.286,5.988,13.927,5.988l-.27,2.607s9.655,6.257,19,.384a74.85,74.85,0,0,1,3.016-19.563c2.242-8.1.159-18.152-.916-18.914a59.431,59.431,0,0,0-5.906-3.164s-9.958,7.338-11.477,14.422a119.556,119.556,0,0,0-2.155,14.749Z",
    transform: "translate(-333.622 -264.791)",
    fill: "#f6c342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9571",
    "data-name": "Trac\\xE9 9571",
    d: "M373.515,334.157s8.474,2.4,10.661.793,7.6-18.663,7.6-18.663-1.033,8.335-2.136,11.768-2.75,11.1-5.287,11.608c-4.922.986-11.113-2.9-11.113-2.9Z",
    transform: "translate(-337.57 -270.797)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9572",
    "data-name": "Trac\\xE9 9572",
    d: "M383.246,309.125s-1.9,14.586-3.359,14.7a20.524,20.524,0,0,1-4.632-.747s3.177-1.531,4-3.9S383.246,309.125,383.246,309.125Z",
    transform: "translate(-338.021 -269.191)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9573",
    "data-name": "Trac\\xE9 9573",
    d: "M387.224,292.629l1.048-3.684,9.528-1.928-.323,5.091Z",
    transform: "translate(-340.705 -264.233)",
    fill: "#feab44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9574",
    "data-name": "Trac\\xE9 9574",
    d: "M370.979,289.146s-4.533-4.585-2.13-4.74S372.9,290,372.9,290Z",
    transform: "translate(-336.427 -263.647)",
    fill: "#ffa397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9575",
    "data-name": "Trac\\xE9 9575",
    d: "M389.907,270.052c-.238.353-.317.737-.178.857s.445-.068.683-.421.318-.737.178-.858S390.145,269.7,389.907,270.052Z",
    transform: "translate(-341.251 -260.326)",
    fill: "#3a2a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9576",
    "data-name": "Trac\\xE9 9576",
    d: "M387.156,277.151l1.787.364s-.2,1.328-1.157,1.113S387.156,277.151,387.156,277.151Z",
    transform: "translate(-340.678 -262.021)",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6759",
    "data-name": "Groupe 6759",
    transform: "translate(126.864 32.497)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 130.079,
    height: 79.775,
    rx: 6.136,
    transform: "translate(130.079 79.775) rotate(180)",
    fill: "#d6cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9577",
    "data-name": "Trac\\xE9 9577",
    d: "M279.977,55.491V110.96A1.973,1.973,0,0,1,278,112.934H160.166a1.974,1.974,0,0,1-1.974-1.974V55.491Z",
    transform: "translate(-154.489 -37.653)",
    fill: "#fff",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 15.238,
    cy: 15.238,
    r: 15.238,
    transform: "matrix(0.853, -0.522, 0.522, 0.853, 77.595, 40.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9578",
    "data-name": "Trac\\xE9 9578",
    d: "M189.146,78.793H227.6a4.118,4.118,0,0,0,4.106-4.106h0a4.118,4.118,0,0,0-4.106-4.106H189.146a4.118,4.118,0,0,0-4.106,4.106h0A4.118,4.118,0,0,0,189.146,78.793Z",
    transform: "translate(-160.51 -41.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9579",
    "data-name": "Trac\\xE9 9579",
    d: "M189.146,96.293H227.6a4.118,4.118,0,0,0,4.106-4.106h0a4.118,4.118,0,0,0-4.106-4.106H189.146a4.118,4.118,0,0,0-4.106,4.106h0A4.118,4.118,0,0,0,189.146,96.293Z",
    transform: "translate(-160.51 -44.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9580",
    "data-name": "Trac\\xE9 9580",
    d: "M209.532,113.792h22.644a4.118,4.118,0,0,0,4.106-4.106h0a4.118,4.118,0,0,0-4.106-4.106H209.532a4.118,4.118,0,0,0-4.106,4.106h0A4.118,4.118,0,0,0,209.532,113.792Z",
    transform: "translate(-165.082 -48.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9581",
    "data-name": "Trac\\xE9 9581",
    d: "M158.192,43.475a3.708,3.708,0,1,0,3.708-3.708A3.708,3.708,0,0,0,158.192,43.475Z",
    transform: "translate(-154.489 -34.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9582",
    "data-name": "Trac\\xE9 9582",
    d: "M171.828,43.475a3.708,3.708,0,1,0,3.708-3.708A3.708,3.708,0,0,0,171.828,43.475Z",
    transform: "translate(-157.547 -34.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9583",
    "data-name": "Trac\\xE9 9583",
    d: "M185.463,43.475a3.708,3.708,0,1,0,3.708-3.708A3.708,3.708,0,0,0,185.463,43.475Z",
    transform: "translate(-160.605 -34.127)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6760",
    "data-name": "Groupe 6760",
    transform: "translate(223.917 32.887)"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9584",
    "data-name": "Trac\\xE9 9584",
    d: "M386.583,110.949l-4.2,1.41s-7.526-14.9-10.333-19.7c-1.952-3.34-8.412-12.986-8.412-12.986-1.583,14.147-9.04,26.629-9.04,26.629l-11.819-9.918,3.847-23.181s-11.885-1.595-17.809-6.737c-4.975-4.318-8-18-8-18l2.565-1.1S330.549,60.4,333.8,62.352c2.209,1.325,9.681,2.6,13.722,2.454,2.039-.075,5.737,1.173,7.767,1.385,4.187.435,8.332-.77,10.885,2.247C369.746,72.661,386.583,110.949,386.583,110.949Z",
    transform: "translate(-288.012 -36.222)",
    fill: "#fdb8a3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9585",
    "data-name": "Trac\\xE9 9585",
    d: "M336.722,107.138s-22.308-5.73-27.532-4.945c-9.3,1.4-18.931,31.208-18.931,31.208l5.658,3.144c7.509-6.828,17.23-28.608,19.444-27.537s19.964,16.947,19.964,16.947l13.11-7.78Z",
    transform: "translate(-281.158 -48.5)",
    fill: "#1d2223"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9586",
    "data-name": "Trac\\xE9 9586",
    d: "M410.439,133.7l-7.387-4.369-3.495.941s-6.032,3.98-5.22,3.98,1.786,0,5.035-2.46C401.057,130.513,407.027,136.242,410.439,133.7Z",
    transform: "translate(-304.481 -54.601)",
    fill: "#fdb8a3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9587",
    "data-name": "Trac\\xE9 9587",
    d: "M323,45.244s-.649-11.217-2.4-12.192,0,12.194,0,12.194Z",
    transform: "translate(-287.786 -33)",
    fill: "#fdb8a3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9588",
    "data-name": "Trac\\xE9 9588",
    d: "M367.548,60.288v5.126a8.522,8.522,0,0,1-4.347,1c-1.9-.3-1.744-1.2-1.744-1.2l0-4.432a10.985,10.985,0,0,1-3.869-.5c-.482-.23-.808-1.957-.9-4.132-.016-.358-1.444-.211-1.446-.589-.005-.789,1.617-3.1,1.637-3.629.159-4.077.56-4.478,1.524-5.419,2.264-2.211,7.7-2.513,8.6-.5S367.548,60.288,367.548,60.288Z",
    transform: "translate(-295.73 -35.617)",
    fill: "#fdb8a3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9589",
    "data-name": "Trac\\xE9 9589",
    d: "M323.177,168.2h0l-1.269-3.246,6.468.043.627,2.569.539,2.274a1.609,1.609,0,0,1-1.244,1.948l-11.051,2.254C315.841,172.2,320.463,170.173,323.177,168.2Z",
    transform: "translate(-287.152 -62.59)",
    fill: "#fdb8a3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9590",
    "data-name": "Trac\\xE9 9590",
    d: "M286.922,145.132l1.369-2.319,4.795,2.567-1.194,2.3-1.069,2.513a1.28,1.28,0,0,1-1.717.526l-10.055-5.238C278.985,143.127,284.016,144.344,286.922,145.132Z",
    transform: "translate(-278.645 -57.625)",
    fill: "#fdb8a3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9591",
    "data-name": "Trac\\xE9 9591",
    d: "M377.243,72.449s-4.661-7.184-8.348-6.768c-5.176.585-5.89-7.17-4.492-8.994.742-.969,2.855-4.021,1.138-5.115-2.179-1.388-2.472,1.185-3.47,1.157-1.984-.058-6.129-5.367-3.855-6.939,4.843-3.348,14.61-2.544,13.621,6.827C370.936,61.166,377.243,72.449,377.243,72.449Z",
    transform: "translate(-296.249 -35.464)",
    fill: "#feab44"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9592",
    "data-name": "Trac\\xE9 9592",
    d: "M353.637,118.494s-2.894,10.812-9.364,10.812-20.325-9.66-20.325-9.66l4.262,32.4-7.1-.043s-12.425-36.059-5.613-43.4c4.644-5.005,31.545,4.913,31.545,4.913Z",
    transform: "translate(-286.362 -49.636)",
    fill: "#2e3537"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9593",
    "data-name": "Trac\\xE9 9593",
    d: "M362.712,105.344,346.628,93.623l2.39-14.169-10.434-3.942,1.983-8.83s12.967,2.385,14.565,2.715.656,4.548,4.52,5.454c4.233.991,5.205-3.8,6.362-3.8s6.18.932,9.4,7.726c3.077,6.488,5.3,12,5.3,12l-7.731,3.736-4-7.105Z",
    transform: "translate(-291.995 -40.553)",
    fill: "#f6c342"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9594",
    "data-name": "Trac\\xE9 9594",
    d: "M376.949,92.446l-2.868-3.3,1.077,8.421Z",
    transform: "translate(-299.956 -45.589)",
    fill: "#bc6317"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9595",
    "data-name": "Trac\\xE9 9595",
    d: "M328.315,172.8l-11.094,2.263s-1.233-.941,1-2.809c.853-.714,2.448,2.516,8.892-1.389l2.084-1.358.331,1.4A1.567,1.567,0,0,1,328.315,172.8Z",
    transform: "translate(-287.129 -63.611)",
    fill: "#3a2a4e"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9596",
    "data-name": "Trac\\xE9 9596",
    d: "M288.292,151.622l-9.764-5.695s.144-1.673,2.616-1.43c1.106.109.149,3.507,7.556,4.89l2.459.376-.674,1.244A1.585,1.585,0,0,1,288.292,151.622Z",
    transform: "translate(-278.528 -57.997)",
    fill: "#3a2a4e"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9597",
    "data-name": "Trac\\xE9 9597",
    d: "M358.144,53.467c.024.429.178.769.343.759s.278-.365.254-.794-.178-.769-.343-.759S358.119,53.038,358.144,53.467Z",
    transform: "translate(-296.381 -37.411)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9598",
    "data-name": "Trac\\xE9 9598",
    d: "M358.558,61.113a.519.519,0,0,0,.11-.019c.429-.119.541-.749.546-.776a.083.083,0,0,0-.164-.028c0,.005-.1.553-.427.644-.246.067-.584-.138-.98-.6a.083.083,0,0,0-.126.109C357.915,60.907,358.264,61.13,358.558,61.113Z",
    transform: "translate(-296.237 -39.104)",
    fill: "#ffa397",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.715,
    cy: 2.715,
    r: 2.715,
    transform: "translate(508.209 295.091)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.97367038f833c11f06cfa1f02673c934.svg";
export { ForwardRef as ReactComponent };